import { titleize } from 'utils/strings';

const format = 'MM/DD/YYYY [at] h:mm:ss A';
const momentFormat = {
  sameElse: format,
  lastWeek: format
};
const queueTitle = (queue) => queue ? titleize(queue) : 'Delayed';

export {
  momentFormat,
  queueTitle
};
